import { FC } from 'react';
import { Box, Stack, Theme } from '@mui/material';
import { getFirstLastName } from '../../lib/helpers';
import { createUseStyles } from 'react-jss';
import UserBadge from '../user-badge';
import Text from '../text';
import useApp from '@/hooks/use-app.hook';
import Icon from '../icon';

const useStyles = createUseStyles((theme: Theme) => ({
  mobileUserFooter: {
    position: 'relative',
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: 8,
    padding: 8,
    width: '100%',
    boxSizing: 'border-box',
  },
  logoutButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: theme.zIndex.drawer + 10,
    color: theme.palette.grey[800],
  },
}));

const MobileUserFooter: FC = () => {
  const styles = useStyles();
  const { user, signOut } = useApp();
  const { displayName, email } = user!;
  const username = displayName || '';
  const { first, last } = getFirstLastName(username);
  const hasName = !!first || !!last;

  const handleSignOut = () => {
    signOut();
  };

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      gap={1}
      className={styles.mobileUserFooter}
    >
      <UserBadge user={user!} />
      <Box flexGrow={1} maxWidth="80%">
        {hasName && (
          <Text size="small" dotdot>
            {[first, last].join(' ')}
          </Text>
        )}
        <Text size="small" color={hasName ? 'grey' : 'black'} dotdot>
          {email}
        </Text>
      </Box>
      <Icon name="log-out" className={styles.logoutButton} onClick={handleSignOut} size="small" />
    </Stack>
  );
};

export default MobileUserFooter;
